import { Injectable } from '@angular/core';
import { Observable, of, tap } from'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { UserService } from './user/user.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

//For request caching
type cacheObject = {
  cachedTime: number,
  response: HttpResponse<any>
};
const CacheHeaderName = 'Client-Cache'


/**
 * Custom override of Angular's Http service allowing for interception and modification of all requests.
 */
@Injectable()
export class CustomHttpService implements HttpInterceptor {

    //Holds client side response cache
    private cache = new Map<string, cacheObject>();

    constructor(private userSvc: UserService ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler):  Observable<HttpEvent<any>> {

      //Attach our current auth token to the request
      if (this.userSvc && this.userSvc.details && this.userSvc.details.jwt.access_token
        && !request.url.endsWith("/token")) {
          request = request.clone({
              setHeaders: {
                'Authorization': 'Bearer '+ this.userSvc.details.jwt.access_token
              }
            });
      }

      //Response caching is done here
      //When processing new token request clear the cache
      if (request.url.endsWith("/token")) {
        this.cache.clear();
      }

      const url = request.url.replace(environment.base_api_url, '');
      //For GETs include url params, for POSTs also include body checksum
      let key = request.urlWithParams.replace(environment.base_api_url, '');
      if (request.method === "POST") {
        key += '*' + CryptoJS.MD5(JSON.stringify(request.body)).toString();
      }

      const cachedResponse = this.cache.get(key);
      if (cachedResponse) {
        let cacheTTL = Number(cachedResponse.response.headers.get(CacheHeaderName));
        let expired = Math.floor((new Date().getTime() - cachedResponse.cachedTime)/1000) > cacheTTL;
        if (expired) {
          //console.log('Removing exired cache entry: ', key);
          this.cache.delete(key);
        } else {
          //console.log('Returning cache entry: ', key);
          return of(cachedResponse.response);
        }
      }

      //After processing request, check if the response should be cached
      return next.handle(request).pipe(
        tap((response) => {
          if (response instanceof HttpResponse) {
            if (response.headers.has(CacheHeaderName)) {
              //Combining .get and Number into single statement throws js error
              let cacheTTL = response.headers.get(CacheHeaderName);
              if (Number(cacheTTL) > 0) {
                console.log('Caching: ', key);
                this.cache.set(key, { cachedTime: new Date().getTime(), response: response });
              }
            }
          }
        })
      );
    }
}
